import { useOptionalFilters } from "components/Elements/Filters/FilterContext";

// Returns the current page's raw filterValues object. Resilient when no
// FilterProvider is mounted (e.g. profile-edit flow) — returns an empty
// object so the caller can pass {} as the filterContext.
export const useFilterValues = () => {
	const ctx = useOptionalFilters();
	return ctx?.filterValues || {};
};
